// PT translations
export const pt = {
    // Navigation
    nav: {
      home: 'Início',
      services: 'Serviços',
      about: 'Sobre Nós',
      successStories: 'Casos de Sucesso',
      blog: 'Blog',
      contact: 'Contato'
    },
    // Hero Section
    hero: {
      badge: 'Genealogista Especialista Laura Stella - 30 Anos de Experiência',
      title: 'Descubra Suas',
      titleHighlight: 'Raízes Italianas',
      description: 'Pesquisa genealógica profissional conectando você às suas origens italianas',
      introHeadline: 'Toda história familiar começa com uma pergunta. Nós ajudamos você a encontrar as respostas.',
      introSupport: 'Pesquisa baseada em fontes históricas reais, documentos verificáveis e suporte humano dedicado.',
      cta: 'Comece Sua Jornada',
      viewServices: 'Ver Serviços',
      stats: {
        projects: 'Projetos Concluídos',
        experience: 'Anos de Experiência',
        countries: 'Países Atendidos'
      },
      certified: 'Especialista Certificado',
      certifiedSub: 'Pesquisa em Arquivos Italianos'
    },
    // Services Section
    services: {
      title: 'Nossos Serviços',
      subtitle: 'Soluções completas para pesquisa genealógica',
      items: [
        {
          title: 'Pesquisa Genealógica',
          description: 'Pesquisa aprofundada de arquivos italianos para rastrear a história da sua família através de gerações.'
        },
        {
          title: 'Recuperação de Documentos',
          description: 'Obtemos certidões de nascimento, casamento e óbito de arquivos municipais e paroquiais italianos.'
        },
        {
          title: 'Assistência para Cidadania',
          description: 'Orientação especializada através do processo de solicitação de cidadania italiana por descendência (jure sanguinis).'
        },
        {
          title: 'Tradução de Documentos',
          description: 'Tradução profissional e apostilamento de documentos italianos para uso legal.'
        },
        {
          title: 'Tours Ancestrais',
          description: 'Viagens personalizadas aos locais de origem da sua família na Itália.'
        }
      ]
    },
    // About Section
    about: {
      title: 'Sobre Nós',
      subtitle: 'Seu Parceiro na Descoberta do Patrimônio Italiano',
      description1: 'Com mais de 30 anos de experiência em pesquisa genealógica italiana, Laura Stella ajudou centenas de famílias a descobrir suas raízes italianas e obter a cidadania italiana.',
      description2: 'Nossa equipe de pesquisadores especializados trabalha diretamente com arquivos italianos, paróquias e cartórios para encontrar os documentos necessários para sua pesquisa familiar.',
      features: [
        'Acesso direto a arquivos italianos',
        'Equipe de pesquisadores nativos',
        'Mais de 500 casos de sucesso',
        'Suporte completo para cidadania'
      ]
    },
    // Success Stories
    stories: {
      title: 'Casos de Sucesso',
      subtitle: 'Famílias que descobriram suas raízes',
      items: [
        {
          name: 'Marco R.',
          location: 'Nova York, EUA',
          quote: 'A precisão e a exatidão da pesquisa me surpreenderam. Eles encontraram detalhes sobre minha família que nem meus avós conheciam!'
        },
        {
          name: 'Sarah M.',
          location: 'Sydney, Austrália',
          quote: 'Encontraram documentos da minha família datados de 1800. Uma experiência incrível.'
        },
        {
          name: 'Carlos G.',
          location: 'Buenos Aires, Argentina',
          quote: 'Profissionalismo e dedicação. Resolveram um caso complexo que outros haviam abandonado.'
        }
      ]
    },
    // Blog
    blog: {
      title: 'Blog de Genealogia',
      subtitle: 'Guias, dicas e histórias sobre pesquisa genealógica italiana',
      readMore: 'Ler Artigo',
      backToSite: 'Voltar ao Site',
      backToBlog: 'Voltar ao Blog',
      minRead: 'min de leitura',
      categories: {
        citizenship: 'Cidadania',
        research: 'Pesquisa',
        genealogy: 'Genealogia',
        documents: 'Documentos'
      }
    },
    // Contact
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Comece sua jornada às raízes italianas',
      form: {
        name: 'Nome Completo',
        email: 'E-mail',
        phone: 'Telefone',
        message: 'Mensagem',
        ancestorOrigin: 'Local de origem do seu antepassado (se conhecido)',
        submit: 'Enviar Solicitação'
      },
      info: {
        title: 'Informações de Contato',
        email: 'italianrootsdiscovery@gmail.com',
        phone: '+39 3318792031',
        address: 'Milão • Turim • Gênova • Veneza • Pádua • Roma • Nápoles • Palermo'
      }
    },
    // Footer
    footer: {
      description: 'Pesquisa genealógica profissional conectando você às suas raízes italianas.',
      quickLinks: 'Links Rápidos',
      contactUs: 'Entre em Contato',
      followUs: 'Siga-nos',
      rights: 'Todos os direitos reservados.',
      terms: 'Termos e Condições',
      privacy: 'Política de Privacidade',
      cookies: 'Política de Cookies'
    }
  };
